"use strict";
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _Miner_currentlyExecutingPrice, _Miner_origins, _Miner_pending, _Miner_isBusy, _Miner_paused, _Miner_resumer, _Miner_currentBlockBaseFeePerGas, _Miner_resolver, _Miner_emitStepEvent, _Miner_executables, _Miner_options, _Miner_vm, _Miner_createBlock, _Miner_priced, _Miner_mine, _Miner_mineTxs, _Miner_runTx, _Miner_removeBestAndOrigin, _Miner_reset, _Miner_setPricedHeap, _Miner_updatePricedHeap;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Capacity = void 0;
const ethereum_utils_1 = require("@ganache/ethereum-utils");
const utils_1 = require("@ganache/utils");
const rlp_1 = require("@ganache/rlp");
const trie_1 = require("@ethereumjs/trie");
const emittery_1 = __importDefault(require("emittery"));
const replace_from_heap_1 = __importDefault(require("./replace-from-heap"));
const ethereum_transaction_1 = require("@ganache/ethereum-transaction");
const provider_events_1 = require("../provider-events");
const console_log_1 = require("@ganache/console.log");
/**
 * How many transactions should be in the block.
 */
var Capacity;
(function (Capacity) {
    /**
     * Keep mining transactions until there are no more transactions that can fit
     * in the block, or there are no transactions left to mine.
     */
    Capacity[Capacity["FillBlock"] = -1] = "FillBlock";
    /**
     * Mine an empty block, even if there are executable transactions available to
     * mine.
     */
    Capacity[Capacity["Empty"] = 0] = "Empty";
    /**
     * Mine a block with a single transaction, or empty if there are no executable
     * transactions available to mine.
     */
    Capacity[Capacity["Single"] = 1] = "Single";
})(Capacity || (exports.Capacity = Capacity = {}));
const updateBloom = (blockBloom, bloom) => {
    let i = 256;
    while (i--)
        blockBloom[i] |= bloom[i];
};
const sortByPrice = (values, a, b) => values[a].effectiveGasPrice > values[b].effectiveGasPrice;
const refresher = (item, context) => item.updateEffectiveGasPrice(context);
class Miner extends emittery_1.default {
    async pause() {
        if (!__classPrivateFieldGet(this, _Miner_paused, "f")) {
            __classPrivateFieldSet(this, _Miner_paused, true, "f");
            __classPrivateFieldSet(this, _Miner_resumer, new Promise(resolve => {
                __classPrivateFieldSet(this, _Miner_resolver, resolve, "f");
            }), "f");
        }
        if (__classPrivateFieldGet(this, _Miner_isBusy, "f")) {
            await this.once("idle");
        }
    }
    resume() {
        if (!__classPrivateFieldGet(this, _Miner_paused, "f"))
            return;
        __classPrivateFieldSet(this, _Miner_paused, false, "f");
        __classPrivateFieldGet(this, _Miner_resolver, "f").call(this);
    }
    /*
     * @param executables - A live Map of pending transactions from the transaction
     * pool. The miner will update this Map by removing the best transactions
     * and putting them in new blocks.
     */
    constructor(options, executables, vm, createBlock) {
        super();
        _Miner_currentlyExecutingPrice.set(this, 0n);
        _Miner_origins.set(this, new Set());
        _Miner_pending.set(this, void 0);
        _Miner_isBusy.set(this, false);
        _Miner_paused.set(this, false);
        _Miner_resumer.set(this, void 0);
        _Miner_currentBlockBaseFeePerGas.set(this, void 0);
        _Miner_resolver.set(this, void 0);
        /**
         * Because step events are expensive, CPU-wise, to create and emit we only do
         * it conditionally.
         */
        _Miner_emitStepEvent.set(this, false);
        _Miner_executables.set(this, void 0);
        _Miner_options.set(this, void 0);
        _Miner_vm.set(this, void 0);
        _Miner_createBlock.set(this, void 0);
        // create a Heap that sorts by gasPrice
        _Miner_priced.set(this, new utils_1.Heap(sortByPrice, refresher));
        _Miner_mine.set(this, async (block, maxTransactions = Capacity.FillBlock, onlyOneBlock = false) => {
            const { block: lastBlock, transactions } = await __classPrivateFieldGet(this, _Miner_mineTxs, "f").call(this, block, maxTransactions, onlyOneBlock);
            // if there are more txs to mine, start mining them without awaiting their
            // result.
            if (__classPrivateFieldGet(this, _Miner_pending, "f")) {
                __classPrivateFieldGet(this, _Miner_setPricedHeap, "f").call(this);
                __classPrivateFieldSet(this, _Miner_pending, false, "f");
                if (!onlyOneBlock && __classPrivateFieldGet(this, _Miner_priced, "f").length > 0) {
                    const nextBlock = __classPrivateFieldGet(this, _Miner_createBlock, "f").call(this, lastBlock);
                    await __classPrivateFieldGet(this, _Miner_mine, "f").call(this, nextBlock, maxTransactions);
                }
            }
            return transactions;
        });
        _Miner_mineTxs.set(this, async (runtimeBlock, maxTransactions, onlyOneBlock) => {
            let block;
            const vm = __classPrivateFieldGet(this, _Miner_vm, "f");
            const { pending, inProgress } = __classPrivateFieldGet(this, _Miner_executables, "f");
            const options = __classPrivateFieldGet(this, _Miner_options, "f");
            let keepMining = true;
            const priced = __classPrivateFieldGet(this, _Miner_priced, "f");
            const storageKeys = new Map();
            let blockTransactions;
            do {
                keepMining = false;
                __classPrivateFieldSet(this, _Miner_isBusy, true, "f");
                blockTransactions = [];
                const transactionsTrie = new trie_1.Trie();
                const receiptTrie = new trie_1.Trie();
                // don't mine anything at all if maxTransactions is `0`
                if (maxTransactions === Capacity.Empty) {
                    await vm.stateManager.checkpoint();
                    await vm.stateManager.commit();
                    const finalizedBlockData = runtimeBlock.finalize(transactionsTrie.root(), receiptTrie.root(), utils_1.BUFFER_256_ZERO, vm.stateManager._trie.root(), 0n, // gas used
                    options.extraData, [], storageKeys);
                    this.emit("block", finalizedBlockData);
                    __classPrivateFieldGet(this, _Miner_reset, "f").call(this);
                    return { block: finalizedBlockData.block, transactions: [] };
                }
                let numTransactions = 0;
                let blockGasLeft = options.blockGasLimit.toBigInt();
                let blockGasUsed = 0n;
                const blockBloom = Buffer.allocUnsafe(256).fill(0);
                const promises = [];
                // Set a block-level checkpoint so our unsaved trie doesn't update the
                // vm's "live" trie.
                await vm.stateManager.checkpoint();
                const TraceData = (0, ethereum_utils_1.TraceDataFactory)();
                // We need to listen for any SSTORE opcodes so we can grab the raw, unhashed version
                // of the storage key and save it to the db along with it's keccak hashed version of
                // the storage key. Why you might ask? So we can reference the raw version in
                // debug_storageRangeAt.
                const stepListener = (event) => {
                    if (event.opcode.name === "SSTORE") {
                        const key = TraceData.from(utils_1.Quantity.toBuffer(event.stack[event.stack.length - 1])).toBuffer();
                        const hashedKey = (0, utils_1.keccak)(key);
                        storageKeys.set(hashedKey.toString(), { key, hashedKey });
                    }
                };
                vm.evm.events.on("step", stepListener);
                // Run until we run out of items, or until the inner loop stops us.
                // we don't call `shift()` here because we will may need to `replace`
                // this `best` transaction with the next best transaction from the same
                // origin later.
                let best;
                while ((best = priced.peek())) {
                    const origin = best.from.toString();
                    if (best.calculateIntrinsicGas() > blockGasLeft) {
                        // if the current best transaction can't possibly fit in this block
                        // go ahead and run the next best transaction, ignoring all other
                        // pending transactions from this account for this block.
                        //  * We don't replace this "best" transaction with another from the
                        // same account.
                        //  * We do "unlock" this transaction in the transaction pool's `pending`
                        // queue so it can be replaced, if needed.
                        best.locked = false;
                        __classPrivateFieldGet(this, _Miner_removeBestAndOrigin, "f").call(this, origin);
                        continue;
                    }
                    __classPrivateFieldSet(this, _Miner_currentlyExecutingPrice, best.effectiveGasPrice.toBigInt(), "f");
                    // Set a transaction-level checkpoint so we can undo state changes in
                    // the case where the transaction is rejected by the VM.
                    await vm.stateManager.checkpoint();
                    // Set the internal trie's block number (for forking)
                    vm.stateManager._trie.blockNumber = utils_1.Quantity.from(runtimeBlock.header.number);
                    const result = await __classPrivateFieldGet(this, _Miner_runTx, "f").call(this, best, runtimeBlock, origin, pending);
                    if (result !== null) {
                        const gasUsed = result.totalGasSpent;
                        if (blockGasLeft >= gasUsed) {
                            // if the transaction will fit in the block, commit it!
                            await vm.stateManager.commit();
                            blockTransactions[numTransactions] = best;
                            blockGasLeft -= gasUsed;
                            blockGasUsed += gasUsed;
                            // calculate receipt and tx tries
                            const txKey = (0, rlp_1.encode)(numTransactions === 0
                                ? utils_1.BUFFER_EMPTY
                                : (0, utils_1.uintToBuffer)(numTransactions));
                            promises.push(transactionsTrie.put(txKey, best.serialized));
                            const receipt = best.fillFromResult(result, blockGasUsed);
                            promises.push(receiptTrie.put(txKey, receipt));
                            // update the block's bloom
                            updateBloom(blockBloom, result.bloom.bitvector);
                            numTransactions++;
                            const pendingOrigin = pending.get(origin);
                            inProgress.add(best);
                            best.once("finalized").then(() => {
                                // it is in the database (or thrown out) so delete it from the
                                // `inProgress` Set
                                inProgress.delete(best);
                            });
                            // since this transaction was successful, remove it from the "pending"
                            // transaction pool.
                            const hasMoreFromOrigin = pendingOrigin.removeBest();
                            if (hasMoreFromOrigin) {
                                // remove the newest (`best`) tx from this account's pending queue
                                // as we know we can fit another transaction in the block. Stick
                                // this tx into our `priced` heap.
                                keepMining = (0, replace_from_heap_1.default)(priced, pendingOrigin);
                            }
                            else {
                                // since we don't have any more txs from this account, just get the
                                // next best transaction sorted in our `priced` heap.
                                keepMining = __classPrivateFieldGet(this, _Miner_removeBestAndOrigin, "f").call(this, origin);
                            }
                            // if we:
                            //  * don't have enough gas left for even the smallest of transactions
                            //  * Or if we've mined enough transactions
                            // we're done with this block!
                            // notice: when `maxTransactions` is `-1` (AKA infinite), `numTransactions === maxTransactions`
                            // will always return false, so this comparison works out fine.
                            if (blockGasLeft <= ethereum_transaction_1.Params.TRANSACTION_GAS ||
                                numTransactions === maxTransactions) {
                                break;
                            }
                        }
                        else {
                            // didn't fit in the current block
                            await vm.stateManager.revert();
                            // unlock the transaction so the transaction pool can reconsider this
                            // transaction
                            best.locked = false;
                            // didn't fit. remove it from the priced transactions without replacing
                            // it with another from the account. This transaction will have to be
                            // run again in another block.
                            keepMining = priced.removeBest();
                        }
                    }
                    else {
                        // no result means the transaction is an "always failing tx", so we
                        // revert its changes here.
                        // Note: we don't clean up (`removeBest`, etc) because `runTx`'s
                        // error handler does the clean up itself.
                        await vm.stateManager.revert();
                    }
                }
                await Promise.all(promises);
                await vm.stateManager.commit();
                vm.evm.events.removeListener("step", stepListener);
                const finalizedBlockData = runtimeBlock.finalize(transactionsTrie.root(), receiptTrie.root(), blockBloom, vm.stateManager._trie.root(), blockGasUsed, options.extraData, blockTransactions, storageKeys);
                block = finalizedBlockData.block;
                this.emit("block", finalizedBlockData);
                if (onlyOneBlock) {
                    __classPrivateFieldSet(this, _Miner_currentlyExecutingPrice, 0n, "f");
                    __classPrivateFieldGet(this, _Miner_reset, "f").call(this);
                    break;
                }
                else {
                    __classPrivateFieldSet(this, _Miner_currentlyExecutingPrice, 0n, "f");
                    __classPrivateFieldGet(this, _Miner_updatePricedHeap, "f").call(this);
                    if (priced.length !== 0) {
                        runtimeBlock = __classPrivateFieldGet(this, _Miner_createBlock, "f").call(this, block);
                        // if baseFeePerGas is undefined, we are pre london hard fork.
                        // no need to refresh the order of the heap because all Txs only have gasPrice.
                        if (__classPrivateFieldGet(this, _Miner_currentBlockBaseFeePerGas, "f") !== undefined) {
                            priced.refresh(__classPrivateFieldGet(this, _Miner_currentBlockBaseFeePerGas, "f"));
                        }
                    }
                    else {
                        // reset the miner
                        __classPrivateFieldGet(this, _Miner_reset, "f").call(this);
                    }
                }
            } while (keepMining);
            return { block, transactions: blockTransactions };
        });
        _Miner_runTx.set(this, async (tx, block, origin, pending) => {
            const context = {};
            const vm = __classPrivateFieldGet(this, _Miner_vm, "f");
            this.emit("ganache:vm:tx:before", { context });
            // we always listen to the step event even if `#emitStepEvent` is false in
            // case the user starts listening in the middle of the transaction.
            const stepListener = (event) => {
                const logs = (0, console_log_1.maybeGetLogs)(event);
                if (logs)
                    this.emit("ganache:vm:tx:console.log", { context, logs });
                if (!__classPrivateFieldGet(this, _Miner_emitStepEvent, "f"))
                    return;
                this.emit("ganache:vm:tx:step", (0, provider_events_1.makeStepEvent)(context, event));
            };
            vm.evm.events.on("step", stepListener);
            try {
                return await vm.runTx({
                    skipHardForkValidation: true,
                    tx: tx.toVmTransaction(),
                    block: block
                });
            }
            catch (err) {
                const errorMessage = err.message;
                // We do NOT want to re-run this transaction.
                // Update the `priced` heap with the next best transaction from this
                // account
                const pendingOrigin = pending.get(origin);
                if (pendingOrigin.removeBest()) {
                    (0, replace_from_heap_1.default)(__classPrivateFieldGet(this, _Miner_priced, "f"), pendingOrigin);
                }
                else {
                    // if there are no more transactions from this origin remove this tx
                    // from the priced heap and clear out it's origin so it can accept new
                    // transactions from this origin.
                    __classPrivateFieldGet(this, _Miner_removeBestAndOrigin, "f").call(this, origin);
                }
                const e = {
                    execResult: {
                        runState: { programCounter: 0 },
                        exceptionError: { error: errorMessage },
                        returnValue: utils_1.BUFFER_EMPTY
                    }
                };
                const error = new ethereum_utils_1.RuntimeError(tx.hash, e, ethereum_utils_1.RETURN_TYPES.TRANSACTION_HASH);
                tx.finalize("rejected", error);
                return null;
            }
            finally {
                vm.evm.events.removeListener("step", stepListener);
                this.emit("ganache:vm:tx:after", { context });
            }
        });
        _Miner_removeBestAndOrigin.set(this, (origin) => {
            __classPrivateFieldGet(this, _Miner_origins, "f").delete(origin);
            return __classPrivateFieldGet(this, _Miner_priced, "f").removeBest();
        });
        _Miner_reset.set(this, () => {
            __classPrivateFieldGet(this, _Miner_origins, "f").clear();
            // HACK: see: https://github.com/trufflesuite/ganache/issues/3093
            //
            //When the priced heap is reset, meaning we're clearing out the heap
            // and origins list to be set again when the miner is called, loop over
            // the priced heap transactions and "unlock" them (set tx.locked = false)
            //
            // The real fix would include fixing the use of locked, as it's
            // currently overloaded to mean "is in priced heap" and also "is being
            // mined".
            const priced = __classPrivateFieldGet(this, _Miner_priced, "f");
            const length = priced.length;
            const pricedArray = priced.array;
            for (let i = 0; i < length; i++) {
                const bestFromOrigin = pricedArray[i];
                bestFromOrigin.locked = false;
            }
            priced.clear();
            __classPrivateFieldSet(this, _Miner_isBusy, false, "f");
        });
        /**
         * Adds one transaction from each origin into the "priced" heap, which
         * sorts each tx by gasPrice (high to low)
         */
        _Miner_setPricedHeap.set(this, () => {
            const { pending } = __classPrivateFieldGet(this, _Miner_executables, "f");
            const origins = __classPrivateFieldGet(this, _Miner_origins, "f");
            const priced = __classPrivateFieldGet(this, _Miner_priced, "f");
            for (let mapping of pending) {
                const heap = mapping[1];
                const next = heap.peek();
                if (next && !next.locked) {
                    const origin = next.from.toString();
                    origins.add(origin);
                    next.updateEffectiveGasPrice(__classPrivateFieldGet(this, _Miner_currentBlockBaseFeePerGas, "f"));
                    priced.push(next);
                    next.locked = true;
                }
            }
        });
        /**
         * Updates the "priced" heap with transactions from origins it doesn't yet
         * contain.
         */
        _Miner_updatePricedHeap.set(this, () => {
            const { pending } = __classPrivateFieldGet(this, _Miner_executables, "f");
            const origins = __classPrivateFieldGet(this, _Miner_origins, "f");
            const priced = __classPrivateFieldGet(this, _Miner_priced, "f");
            // Note: the `pending` Map passed here is "live", meaning it is constantly
            // being updated by the `transactionPool`. This allows us to begin
            // processing a block with the _current_ pending transactions, and while
            // that is processing, to receive new transactions, updating our `priced`
            // heap with these new pending transactions.
            for (let mapping of pending) {
                const heap = mapping[1];
                const next = heap.peek();
                if (next && !next.locked) {
                    const price = next.effectiveGasPrice.toBigInt();
                    if (__classPrivateFieldGet(this, _Miner_currentlyExecutingPrice, "f") > price) {
                        // don't insert a transaction into the miner's `priced` heap
                        // if it will be better than its last
                        continue;
                    }
                    const origin = next.from.toString();
                    if (origins.has(origin)) {
                        // don't insert a transaction into the miner's `priced` heap if it
                        // has already queued up transactions for that origin
                        continue;
                    }
                    origins.add(origin);
                    next.updateEffectiveGasPrice(__classPrivateFieldGet(this, _Miner_currentBlockBaseFeePerGas, "f"));
                    priced.push(next);
                    next.locked = true;
                }
            }
        });
        __classPrivateFieldSet(this, _Miner_vm, vm, "f");
        __classPrivateFieldSet(this, _Miner_options, options, "f");
        __classPrivateFieldSet(this, _Miner_executables, executables, "f");
        __classPrivateFieldSet(this, _Miner_createBlock, (previousBlock) => {
            const newBlock = createBlock(previousBlock);
            __classPrivateFieldSet(this, _Miner_currentBlockBaseFeePerGas, newBlock.header.baseFeePerGas, "f");
            return newBlock;
        }, "f");
        // initialize the heap with an empty array
        __classPrivateFieldGet(this, _Miner_priced, "f").init([]);
    }
    /**
     * @param maxTransactions: - maximum number of transactions per block. If `-1`,
     * unlimited.
     * @param onlyOneBlock: - set to `true` if only 1 block should be mined.
     *
     * @returns the transactions mined in the _first_ block
     */
    async mine(block, maxTransactions = Capacity.FillBlock, onlyOneBlock = false) {
        if (__classPrivateFieldGet(this, _Miner_paused, "f")) {
            await __classPrivateFieldGet(this, _Miner_resumer, "f");
        }
        // only allow mining a single block at a time (per miner)
        if (__classPrivateFieldGet(this, _Miner_isBusy, "f")) {
            // if we are currently mining a block, set the `pending` property
            // so the miner knows it can immediately start mining another block once
            // it is done with its current work.
            __classPrivateFieldSet(this, _Miner_pending, true, "f");
            __classPrivateFieldGet(this, _Miner_updatePricedHeap, "f").call(this);
            return;
        }
        else {
            __classPrivateFieldSet(this, _Miner_currentBlockBaseFeePerGas, block.header.baseFeePerGas, "f");
            __classPrivateFieldGet(this, _Miner_setPricedHeap, "f").call(this);
            const result = await __classPrivateFieldGet(this, _Miner_mine, "f").call(this, block, maxTransactions, onlyOneBlock);
            this.emit("idle");
            return result;
        }
    }
    toggleStepEvent(enable) {
        __classPrivateFieldSet(this, _Miner_emitStepEvent, enable, "f");
    }
}
_Miner_currentlyExecutingPrice = new WeakMap(), _Miner_origins = new WeakMap(), _Miner_pending = new WeakMap(), _Miner_isBusy = new WeakMap(), _Miner_paused = new WeakMap(), _Miner_resumer = new WeakMap(), _Miner_currentBlockBaseFeePerGas = new WeakMap(), _Miner_resolver = new WeakMap(), _Miner_emitStepEvent = new WeakMap(), _Miner_executables = new WeakMap(), _Miner_options = new WeakMap(), _Miner_vm = new WeakMap(), _Miner_createBlock = new WeakMap(), _Miner_priced = new WeakMap(), _Miner_mine = new WeakMap(), _Miner_mineTxs = new WeakMap(), _Miner_runTx = new WeakMap(), _Miner_removeBestAndOrigin = new WeakMap(), _Miner_reset = new WeakMap(), _Miner_setPricedHeap = new WeakMap(), _Miner_updatePricedHeap = new WeakMap();
exports.default = Miner;
//# sourceMappingURL=miner.js.map